'use client';

import { useEffect } from 'react';

import {
    APP_BRANDING_READY_EVENT,
    hydrateAppBrandingStore,
    syncDocumentTitleFromBranding,
} from '@/providers/app-branding/hydrate-app-branding-store';
import { useAppBrandingStore } from '@/store/app-branding/slice';

/** 将 head script 预取的 AppInfo 同步到 Zustand，监听网络回包事件；title 以 branding 为准 */
export default function AppBrandingBootstrap() {
    useEffect(() => {
        hydrateAppBrandingStore();
        // Next metadata 可能在 commit 后再写 title，下一帧再断言一次
        const rafId = requestAnimationFrame(() => {
            syncDocumentTitleFromBranding(useAppBrandingStore.getState().branding);
        });

        const onReady = (event: Event) => {
            const { detail } = event as CustomEvent;
            if (detail) {
                hydrateAppBrandingStore(detail);
                return;
            }
            hydrateAppBrandingStore();
        };

        window.addEventListener(APP_BRANDING_READY_EVENT, onReady);
        return () => {
            cancelAnimationFrame(rafId);
            window.removeEventListener(APP_BRANDING_READY_EVENT, onReady);
        };
    }, []);

    return null;
}
